(function () {
    var script = document.currentScript;
    var sectionId = script.dataset.sectionId;
    var root = document.getElementById('ZehnCartDrawer-' + sectionId);
    if (!root) return;

    window.__zehnCartDrawers = window.__zehnCartDrawers || {};
    if (window.__zehnCartDrawers[sectionId]) {
      window.__zehnCartDrawers[sectionId]();
    }

    
    var lastFocused = null;
    var closeTimer = null;
    var enterTimer = null;

    /* ---------- scroll lock ---------- */
    function lockScroll(lock) {
      document.body.style.overflow = lock ? 'hidden' : '';
      document.documentElement.style.overflow = lock ? 'hidden' : '';
    }

    function isOpen() {
      return !root.hasAttribute('hidden');
    }

    function open() {
      if (isOpen()) return;
      if (closeTimer) clearTimeout(closeTimer);
      lastFocused = document.activeElement;
      root.removeAttribute('hidden');
      root.classList.remove('is-closing');
      root.classList.add('is-entering');
      if (enterTimer) clearTimeout(enterTimer);
      enterTimer = setTimeout(function () {
        root.classList.remove('is-entering');
      }, 420);
      lockScroll(true);
      var closeBtn = root.querySelector('.zcd-close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (!isOpen()) return;
      root.classList.remove('is-entering');
      root.classList.add('is-closing');
      lockScroll(false);
      closeTimer = setTimeout(function () {
        root.setAttribute('hidden', '');
        root.classList.remove('is-closing');
      }, 300);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    /* ---------- cart mutations ---------- */
    function setBusy(line, busy) {
      if (line) line.setAttribute('data-busy', busy ? 'true' : 'false');
    }

    function announceCount() {
      var count = Number(root.getAttribute('data-count')) || 0;
      document.dispatchEvent(
        new CustomEvent('zehn:cart:updated', {bubbles: true, detail: {count: count}}),
      );
    }

    function swapMarkup(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.querySelector('[data-zehn-cart-drawer]');
      if (!fresh) return;
      // Only the inner markup is replaced, so delegated listeners survive.
      root.innerHTML = fresh.innerHTML;
      root.setAttribute('data-count', fresh.getAttribute('data-count') || '0');
      announceCount();
    }

    function sectionIds() {
      var cartPage = document.querySelector('zehn-cart[data-section-id]');
      return cartPage ? [sectionId, cartPage.dataset.sectionId] : [sectionId];
    }

    function renderSections(sections) {
      if (!sections) return;
      if (sections[sectionId]) swapMarkup(sections[sectionId]);
      // Use the cart page's renderer to retain its discount and stylesheet handling.
      var cartPage = document.querySelector('zehn-cart[data-section-id]');
      if (cartPage && typeof cartPage.renderSections === 'function' && sections[cartPage.dataset.sectionId]) {
        var pageSections = {};
        pageSections[cartPage.dataset.sectionId] = sections[cartPage.dataset.sectionId];
        cartPage.renderSections(pageSections);
      }
    }

    function refresh() {
      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionIds().join(',')), {cache: 'no-store'})
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          renderSections(data);
        })
        .catch(function () {});
    }

    function onPageShow(event) {
      var navigation = window.performance && window.performance.getEntriesByType('navigation')[0];
      if (event.persisted || (navigation && navigation.type === 'back_forward')) refresh();
    }

    function changeLine(key, quantity, line) {
      setBusy(line, true);
      return fetch(script.dataset.cartChangeUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: sectionIds(),
          sections_url: window.location.pathname,
        }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data && data.sections && data.sections[sectionId]) {
            renderSections(data.sections);
          } else {
            return refresh();
          }
        })
        .catch(function () {
          setBusy(line, false);
          return refresh();
        });
    }

    function onCartPageUpdated(event) {
      if (event.detail && event.detail.source === 'zehn-cart') refresh();
    }

    /* ---------- delegated events ---------- */
    function onClick(event) {
      var closer = event.target.closest('[data-zcd-close]');
      if (closer) {
        event.preventDefault();
        close();
        return;
      }

      var changer = event.target.closest('[data-zcd-change]');
      if (changer) {
        event.preventDefault();
        var line = changer.closest('[data-zcd-line]');
        if (!line) return;
        changeLine(line.getAttribute('data-key'), changer.getAttribute('data-zcd-change'), line);
      }
    }

    function onKeyDown(event) {
      if (event.key === 'Escape' && isOpen()) close();
      if (event.key !== 'Tab' || !isOpen() || root.classList.contains('is-closing')) return;

      // Re-rendering cart contents replaces its controls, so keep this list live.
      var focusable = Array.prototype.filter.call(
        root.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'),
        function (element) {
          return element.tabIndex >= 0 && !element.disabled &&
            !element.closest('[hidden], [inert]') && element.getClientRects().length > 0;
        }
      );
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!first) return;

      var active = document.activeElement;
      if (!root.contains(active) || (event.shiftKey ? active === first : active === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
    }

    root.addEventListener('click', onClick);
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('zehn:cart:open', open);
    document.addEventListener('zehn:cart:refresh', refresh);
    document.addEventListener('cart:updated', onCartPageUpdated);
    window.addEventListener('pageshow', onPageShow);

    window.ZehnCartDrawer = {open: open, close: close, refresh: refresh};

    window.__zehnCartDrawers[sectionId] = function () {
      lockScroll(false);
      if (closeTimer) clearTimeout(closeTimer);
      if (enterTimer) clearTimeout(enterTimer);
      root.removeEventListener('click', onClick);
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('zehn:cart:open', open);
      document.removeEventListener('zehn:cart:refresh', refresh);
      document.removeEventListener('cart:updated', onCartPageUpdated);
      window.removeEventListener('pageshow', onPageShow);
    };
  })();
